(() => {
  const styleId = 'pamo-whatsapp-safe-position';
  const bottomObstacles = ['sticky-atc-panel', '#PBarNextFrameWrapper'];
  const observers = [];
  let frame;

  const isVisible = (element) => {
    const style = window.getComputedStyle(element);
    const rect = element.getBoundingClientRect();
    return style.display !== 'none'
      && style.visibility !== 'hidden'
      && Number.parseFloat(style.opacity || '1') > 0
      && rect.width > 0
      && rect.height > 0
      && rect.top < window.innerHeight
      && rect.bottom >= window.innerHeight - 1;
  };

  const ensureStyle = (root) => {
    if (root.getElementById(styleId)) return;
    const style = document.createElement('style');
    style.id = styleId;
    style.textContent = '@media screen and (max-width: 749px){.gty-wacb-wrapper{right:16px!important;bottom:var(--pamo-whatsapp-bottom,calc(16px + env(safe-area-inset-bottom,0px)))!important}}';
    root.append(style);
  };

  const updatePosition = () => {
    frame = undefined;
    const host = document.querySelector('gty-whatsapp-chat-button');
    const root = host?.shadowRoot;
    if (!host || !root) return false;

    ensureStyle(root);
    if (window.innerWidth > 749) {
      host.style.removeProperty('--pamo-whatsapp-bottom');
      return true;
    }

    let bottom = 16;
    bottomObstacles.forEach((selector) => {
      document.querySelectorAll(selector).forEach((element) => {
        if (!isVisible(element)) return;
        const rect = element.getBoundingClientRect();
        bottom = Math.max(bottom, Math.ceil(window.innerHeight - rect.top) + 16);
      });
    });
    host.style.setProperty('--pamo-whatsapp-bottom', `${bottom}px`);
    return true;
  };

  const scheduleUpdate = () => {
    if (frame) return;
    frame = window.requestAnimationFrame(updatePosition);
  };

  const observeObstacle = (element) => {
    const resizeObserver = new ResizeObserver(scheduleUpdate);
    resizeObserver.observe(element);
    const mutationObserver = new MutationObserver(scheduleUpdate);
    mutationObserver.observe(element, {
      attributes: true,
      attributeFilter: ['class', 'style', 'hidden']
    });
    observers.push(resizeObserver, mutationObserver);
  };

  bottomObstacles.forEach((selector) => {
    document.querySelectorAll(selector).forEach(observeObstacle);
  });

  window.addEventListener('resize', scheduleUpdate, { passive: true });
  window.addEventListener('scroll', scheduleUpdate, { passive: true });
  document.addEventListener('shopify:section:load', scheduleUpdate);

  if (!updatePosition()) {
    let attempts = 0;
    const timer = window.setInterval(() => {
      attempts += 1;
      if (updatePosition() || attempts >= 40) window.clearInterval(timer);
    }, 250);
  }
})();
